<template>
  <div class="searchContent">
    <div class="page-item route">
        <div class="content" v-if="key!=''&&key!=null&&key!=undefined">
            <span>全部结果</span>
            <span>
              <i class="icon icon-more"></i>
            </span>
            <a>{{key}}</a>
        </div>        
    </div>
    <div class="page-item">
            <div class="content">
                <div class="searchtree">
                    <div class="searchtree-item" v-if="categorylist.length>0&&!supplierId" >
                        <div class="searchtree-label">分类:</div>
                        <ul>
                            <li v-for="(cate,j) in categorylist" :key="j" :class="categoryId==cate.value?'on':''"  @click="clickCate(cate.value)">
                                {{cate.name}}
                            </li>        
                            <!-- <li   :class="categoryId==0?'on':''"  @click="clickCate(0)">全部</li>                     -->
                        </ul>
                    </div>
                    <div class="searchtree-item" v-if="brandlist.length>0&&!supplierId" >
                        <div class="searchtree-label">品牌:</div>
                        <ul style="flex-wrap:wrap" v-if="!isShowMoreBrand">
                            <li v-for="(brand,i) in showBrandlist" :key="i"  :class="brandId==brand.value?'on':''" @click="clickBrand(brand.value)">
                                {{brand.name}}
                            </li>                  
                            <!-- <li :class="brandId==0?'on':''"  @click="clickBrand(0)">全部</li>    -->
                            <li v-if="brandlist.length>24" class="brandBtn" @click="setBrandShow(true)">展开<i class="icon icon-list" ></i></li>   
                        </ul>
                       
                        <ul style="flex-wrap:wrap" v-if="isShowMoreBrand">
                            <li v-for="(brand,i) in brandlist" :key="i"  :class="brandId==brand.value?'on':''" @click="clickBrand(brand.value)">
                                {{brand.name}}
                            </li>                  
                            <!-- <li :class="brandId==0?'on':''"  @click="clickBrand(0)">全部</li>     -->
                            <li v-if="brandlist.length>24" class="brandBtn" @click="setBrandShow(false)">收缩<i class="icon icon-list1" ></i></li>        
                        </ul>
                    </div>
                    <div class="searchtree-item supplierInfo" v-if="supplierId>0" >
                        <div class="searchtree-label">店铺:</div>
                        <img class="shopLogo" :src="supplierLogo" />
                        <span class="shopName">{{supplierName}}</span>
                        <div class="supplierCollect">
                          <input type="button" v-if="isLogined && !isCollectSupplier" class="collectBtn" value="收藏店铺" @click="handleCollect()">                        
                          <input type="button" v-if="isLogined && isCollectSupplier"  class="collectBtn1" value="移除收藏" @click="handleRemoveCollect()" >
                        </div>
                    </div>
                    <div class="searchtree-item">
                        <div class="searchtree-label">排序:</div>
                        <ul>
                            <li :class="sortType==1?'on':''" @click="sortFun(1)">
                              综合                              
                            </li>
                            <li :class="(sortType==2||sortType==3)?'on':''" @click="sortFun(sortType==2?3:2)">
                              价格       
                              <i :class="'icon '+ (sortType==2?'icon-sort0':'icon-sort1')"></i>   
                            </li>                          
                            <li :class="sortType==4?'on':''" @click="sortFun(4)">
                              销量                              
                            </li>
                            <li :class="sortType==5?'on':''" @click="sortFun(5)">
                              新品                              
                            </li>
                        </ul>
                    </div>
                </div>
                <div class="tabcontent" v-loading="loading" element-loading-text="数据加载中,请稍后...">
                    <ul>
                        <li v-for="(item,i) in goods" :key="i">
                                <div class="productIamge">
                                  <img :src="item.defaultImage" @click="toDetail(item.id)"/>
                                  <img class="productIcon" v-for="(labelItem,labelIndex) in item.labels" v-if="labelIndex<1&&labelItem.labelIcon" :key="labelIndex" :src="labelItem.labelIcon" />
                                </div>
                                <div class="productname">
                                    {{item.name}}
                                </div>
                                <div class="productprice">
                                    <span class="price">
                                      ￥{{item.settlementPrice}}
                                      <span class="scribe" v-if="item.settlementPrice<item.sellPrice">
                                        ￥{{item.sellPrice}}
                                    </span>
                                    </span>
                                   
                                    <span class="sales">
                                        成交{{item.sales}}件
                                     </span>
                                </div>                          
                            <div class="operationBtn">
                              <a  @click="toDetail(item.id)"><y-button text="查看详情"></y-button></a>                      
                              <y-button text="加入购物车"
                                @btnClick="showModal(item)"
                                classStyle="main-btn"
                              ></y-button>
                            </div>
                        </li>                       
                    </ul>                    
                </div>
                <el-pagination
                      v-if="!noResult&&!error"
                      @current-change="handleCurrentChange"
                      :page-size="pageSize"
                      @size-change="handleSizeChange"
                      :current-page.sync="currentPage3"
                      layout="prev, pager, next, jumper"
                      :total="goodsTotal">
                    </el-pagination>
            </div>
          </div>        
        <selectSpec ref="selectSpec"></selectSpec>
  </div>
</template>
<style>
@import '../../styles/search.css';
</style>
<script>
//   import { getSearch } from '/api/goods.js'
  import api from '@/api'
  import { getCategorys, getBrands } from '@/api/homePage'
  import { collect, doRemoveCollect, getCollectSuppliers } from '@/api/supplier'
  import mallGoods from '@/components/mallGoods'
  import YButton from '@/components/yButton'
  import YShelf from '@/components/shelf' 
  import SelectSpec from './components/SelectSpec' 
  import {mapGetters, mapActions,mapMutations,mapState} from 'vuex'
  export default {
    data () {
      return {
        showSpecModal:false,
        error: false,
        loading: true,
        searching: true,
        timer: null,
        sortType: null,
        sort: '',
        currentPage: 1,
        pageSize: 50,
        total: 0,
        key: '',
        searchType: '0',
        isShowMoreBrand:false,
        showBrandlist:[],
        brandlist:[],
        categorylist:[],
        categoryId:0,
        parentCateId:0,
        navigationId:0,
        brandId:0,
        keyType:0,
        sorting:'',
        sortAsc:false,
        currentPage3:1,
        productDetail:{},
        supplierId:undefined,
        supplierLogo:'',
        supplierName:'',
        isCollectSupplier:false,
      }
    },
    methods: {
      fetchData() {
        
      },
      showModal(item){      
        this.$refs['selectSpec'].showSelect(item)    
      //   this.productDetail=item;
      //  if(item.frontendPropertyInfo.length){
      //    this.showSpecModal = true
      //  }else{
      //    let specId = item.productSpecs[0].id
      //    let specName = item.productSpecs[0].specName
      //    this.addCart(item.id, item.settlementPrice, item.name, item.defaultImage,specId,specName,1);
      //  } 
       },
       handleCollect()
       {
        var _this=this;      
        collect({id:this.supplierId}).then(res=>{
          _this.initialCollectSuppliers()
          _this.$message({ message: '收藏完成', type: 'success', customClass: 'c-msg' }) 
        });        
       },   
       handleRemoveCollect()
       {
        doRemoveCollect({SupplierId:this.supplierId}).then(res=>{
          this.initialCollectSuppliers()
          this.$message({ message: '移除成功', type: 'success', customClass: 'c-msg' }) 
        });   
       },
       initialCollectSuppliers()
        {   
          if(this.isLogined)
          {       
           getCollectSuppliers({SkipCount:0,MaxResultCount:1000}).then(res=>{          
              var item = res.data.result.find(p=>p.supplierId==this.supplierId);
               if(item)this.isCollectSupplier=true;
               else this.isCollectSupplier=false;
            })
         }
        },
       setBrandShow(val)
       {
        this.isShowMoreBrand=val;
       },
       addSpecCart(id, price, name, img){
        let specId= this.checkAttr()
         if(!specId){
           return
         }
        let specName = ''
        this.msg.productSpecs.forEach((item) => {
          if (item.id === specId){
            specName = item.specName
          }
        })
         
        this.addCart(id, price, name, img, specId, specName,this.num)
      },
       addCart (id, price, name, img, specId, specName,num) {
         this.ADD_CART({
            productId: id,
            settlementPrice: price,
            name: name,
            defaultImage: img,
            num: num,
            specId: specId,
            specName:specName
          })
          // 加入购物车动画
          var dom = event.target
          // 获取点击的坐标
          let elLeft = dom.getBoundingClientRect().left + (dom.offsetWidth / 2)
          let elTop = dom.getBoundingClientRect().top + (dom.offsetHeight / 2)
          let imgs= "http://localhost:8888/static/images/logo.png"
          // 需要触发
          this.ADD_ANIMATION({moveShow: true, elLeft: elLeft, elTop: elTop, img: imgs})
          if (!this.showCart) {
            this.SHOW_CART({showCart: true})
          }
      },


      handleIconClick (ev) {
        console.log(123131)
          
      },
      handleSizeChange (val) {
        this.pageSize = val
        this._getSearch()
      },
      handleCurrentChange (val) {
        this.currentPage = val
        this._getSearch()
      },
      async _getSearch () {     
        this.loading=true;  
        let MaxResultCount =  this.pageSize
        let SkipCount = (this.currentPage - 1) * this.pageSize
        let params = {
            skipCount: SkipCount,
            maxResultCount: MaxResultCount,
            categoryId:this.categoryId,
            brandId:this.brandId,
            sortAsc:this.sortAsc,
            sorting:this.sorting,
            name: this.key,
            searchKeyType:this.keyType,
            mainCateTypeId:this.categoryId>0?this.categoryId:this.parentCateId,
            navigationId:this.navigationId,
            supplierId:this.supplierId
        }
        await this.loadGoodsList(params)
        debugger
        if(this.supplierId>0)
        {
          this.initialCollectSuppliers()
        }
        this.loading = false
        this.searching = false
       
      }, 
      toDetail(id)
      {
        window.open('//' + window.location.host + '/#/goodsDetails?productId=' + id)
      },
      sortFun(val)
      {
         this.loading=true;
         this.currentPage = 1
         switch(val)
         {
            case 1:
              this.sortType = 1;
              this.sorting = '';
              this.sortAsc = false;
              break;
            case 2://价格升序
              this.sortType = 2;
              this.sorting = 'price';
              this.sortAsc = true;
              break;
            case 3://价格降序
              this.sortType = 3;
              this.sorting = 'price';
              this.sortAsc = false;
              break;
            case 4://销售降序
              this.sortType = 4;
              this.sorting = 'sales';
              this.sortAsc = false;
              break;
            case 5://新品降序
              this.sortType = 5;
              this.sorting = 'new';
              this.sortAsc = false;
              break;
         }
         this._getSearch();
      },    
      clickBrand(v){
        this.brandId = v
        this._getSearch()
      },
      clickCate(v) {
        this.categoryId = v
        this._getSearch()
      },
      async _getBrands() {
        var tempParam={
          cateId:this.parentCateId,
          navigationId:this.navigationId,
          brandName:this.searchType=='1'?this.key:'',
          productName:this.searchType=='0'?this.key:'',
        };
        await getBrands(tempParam).then(res => {
         this.brandlist = res.data.result.items
         this.showBrandlist = [];
         for(var i=0;i<this.brandlist.length&&i<24;i++)
          {
            this.showBrandlist.push(this.brandlist[i]);
          }
        })
      },
      async _getCategory() {       
        var pCateId = null;
        if(this.parentCateId>0)pCateId = this.parentCateId;    
        var tempParam={
          cateId:this.pCateId,
          navigationId:this.navigationId,
          productName:this.searchType=='0'?this.key:'',
        };
        await getCategorys(tempParam).then(res => {          
          this.categorylist = res.data.result.items
        })  
      },
      ...mapMutations(['ADD_CART', 'ADD_ANIMATION', 'SHOW_CART']),
      ...mapActions([
       'loadGoodsList',
      ])
    },
    created () {
      let id = this.$route.query.productId
      if(this.$route.query.parentCateId)
      {
        this.parentCateId = parseInt(this.$route.query.parentCateId)
      }
    },
    computed: {
      ...mapGetters([
        'goods',
        'goodsTotal',
        'noResult'
      ]),
      ...mapState(['isLogined']), 
    },
    mounted () {
      this.key = this.$route.query.key    
      if(this.$route.query.searchType)
      {
        this.searchType = this.$route.query.searchType
      }
      this.navigationId = this.$route.query.navigationId || 0
      this.categoryId = this.$route.query.cateId || 0
      this.keyType = this.keyType || 0
      if(this.searchType=='1'||this.searchKeyType==1)
      {
        this.keyType=2;
      }
      if(this.searchType=='2'||this.searchKeyType==2)
      {
        this.keyType=3;
      }
      this.sortType = this.$route.query.sort || 1;
      this.sortType = parseInt(this.sortType);
      this.supplierName =  this.$route.query.sName;
      this.supplierLogo =  this.$route.query.sLogo;
      var tempSupplierId = this.$route.query.sId;
      if(tempSupplierId)
      {
        this.supplierId = parseInt(tempSupplierId);
      }
      this.sortFun(this.sortType);
      if(!this.supplierId)
      {
      this._getBrands()
      if(this.searchType!='1'&&this.searchKeyType!=1)
      {
        this._getCategory()
      }
     }
    },
    components: {
      YButton,    
      YShelf,
      SelectSpec
    }
  }
</script>



// WEBPACK FOOTER //
// index.vue?451495ca